webpackJsonp([11574605485873],{

/***/ 1959:
/***/ (function(module, exports) {

	module.exports = {"pathContext":{"name":"ProtocolReminderByProtocol","kind":"OBJECT","type":"OBJECT","fields":[{"args":[],"deprecationReason":null,"description":null,"isDeprecated":false,"name":"id","type":{"kind":"SCALAR","name":"ID","ofType":null}},{"args":[],"deprecationReason":null,"description":null,"isDeprecated":false,"name":"protocol","type":{"kind":"OBJECT","name":"Protocol","ofType":null}},{"args":[],"deprecationReason":null,"description":null,"isDeprecated":false,"name":"protocolReminder","type":{"kind":"OBJECT","name":"ProtocolReminder","ofType":null}}],"description":null,"enumValues":null,"possibleTypes":null}}

/***/ })

});


// WEBPACK FOOTER //
// path---object-protocol-reminder-by-protocol-9674fcd296cdac65a8c4.js